import * as Yup from 'yup'

const holidaySchema = Yup.object().shape({
    title: Yup.string().required('Required'),
    holidayDate: Yup.string().required('Required'),
})

export { holidaySchema }
